import script from "./ChatComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatComponent.vue?vue&type=script&setup=true&lang=js"

import "./ChatComponent.vue?vue&type=style&index=0&id=19e2de88&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19e2de88"]])

export default __exports__